import { Component, OnInit } from '@angular/core';
import { ProductCreateComponent } from './product.create';
import { ProductImage } from '../Models/product';


/**
 * This component handles product update. It extents product.create
 * as it does almost the same...
 */
export class ProductUpdateComponent extends ProductCreateComponent {

  public mode = "update";

  protected handleSubmit(): void {

    this.productService.update(this.model).subscribe(
      data => {
        this.alertService.success("Updated new product");
        this.router.navigate(['pages', 'product_updated']);
      },
      error => {
        this.alertService.error("Error saving product!");
        this.submitted = false;
      }
    );
  }

  /**
   * Extend init so as to load model to edit.
   */
  ngOnInit() {
    super.ngOnInit();

    this.route.params.subscribe(params => {
      let id = +params['id'];

      this.productService.get(id).subscribe(
        product => {
          this.model = product;
          this.loadSizes();

          for (let i = 0; i < this.numberOfExtraImages; ++i) {
            if (!this.model.images[i]) {
              this.model.images.push({'image': new ProductImage()});
            }
          }

          if (this.model.custom_size) {
            this.model.size = -1;
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/product.update.ts